import React from "react"

class Error extends React.Component{
    render(){
        return <div>
                Page do not exist
             </div>
    }   
}

export default Error